import * as yup from "yup";
import { Form } from "@/components/organisms/Form";
// import { School } from "@/common/types/school";
// import { request } from "@/common/api";
import { useForm } from "react-hook-form";
import { Buttons } from "@/components/atoms/Buttons";
// import { useQuery } from "@tanstack/react-query";
// import { showAlert } from "@/components/containers/Alert";
import { agreeState } from "@/common/states/agree";
import { InputGroup } from "@/components/molecules/InputGroup";
import { TelControl } from "@/components/containers/Controls/TelControl";
import { useNavigate } from "react-router";
// import { GET_SCHOOLS } from "@/common/querykeys";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputSelect } from "@/components/atoms/Inputs/InputSelect";
import { TextControl } from "@/components/containers/Controls/TextControl";
import { FormInputBox } from "@/components/molecules/FormInputBox";
import { JoinTemplate } from "@/components/templates/JoinTemplate";
import { RadioControl } from "@/components/containers/Controls/RadioControl";
// import { SelectControl } from "@/components/containers/Controls/SelectControl";
import { useRecoilValue } from "recoil";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";
import { useEffect, useState } from "react";
import { useJoinFormHandlers } from "@/common/hooks/useJoinFormHandlers";

const schema = yup.object({
  student: yup.object({
    name: yup
      .string()
      .matches(/^[a-zA-z가-힣]+$/, "이름은 한글 및 영문만 입력 가능합니다.")
      .max(20, "이름은 최대 20자까지 입력 가능합니다.")
      .required("이름은 필수 입력입니다."),
    birth: yup
      .date()
      .typeError(
        "생년월일은 YYYY-MM-DD 형식이어야 하며, 유효한 날짜여야 합니다."
      )
      .required("생년월일은 필수 입력입니다."),
    gender: yup.string().required("성별은 필수 입력입니다."),
    tel: yup
      .string()
      .length(
        13,
        "연락처는 000-0000-0000 형식이며, 13자에 맞게 작성하셔야 합니다."
      )
      .required("연락처는 필수 입력입니다."),
    schoolId: yup.string().required("학교 ID는 필수 입력입니다."),
    studentIdNumber: yup
      .string()
      .max(20, "학번은 최대 20자까지 입력 가능합니다."),
    agreementTime1: yup
      .date()
      .required("서비스 이용 안내 동의 시간은 필수 입력입니다.")
      .typeError("동의 시간 1은 유효한 날짜여야 합니다."),
    agreementTime2: yup
      .date()
      .required(
        "개인정보 수집∙이용 및 제3자 제공 동의 시간은 필수 입력입니다."
      ),
  }),
  join: yup.object({
    entityType: yup.string().required("참여 유형은 필수 입력입니다."),
    organizationName: yup.string().when("entityType", {
      is: "organization",
      then: (schema) => schema.required("소속 기관 이름은 필수 입력입니다."),
      otherwise: (schema) => schema.strip(),
    }),
  }),
});

export const JoinStudentFormPage = () => {
  const navigate = useNavigate();
  const [schoolType, setSchoolType] = useState<string>();

  const {
    student,
    joinComm,
    handleNameChange,
    handleBirthChange,
    handleGenderChange,
    handleNumberChange,
    handleEtcNameChange,
    // handleSchoolIdChange,
    handleEntityTypeChange,
    handleSchoolTypeChange,
    handleStudentIdNumberChange,
    handleOrganizationNameChange,
  } = useJoinFormHandlers();
  const agree = useRecoilValue(agreeState);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      student: {
        tel: student.tel,
        name: student.name,
        birth: student.birth,
        gender: student.gender,
        schoolId: student.schoolId,
        agreementTime1: agree?.agreementTime1!,
        agreementTime2: agree?.agreementTime2!,
        studentIdNumber: student.studentIdNumber,
      },
      join: {
        entityType: joinComm.entityType,
        organizationName: joinComm.organizationName,
      },
    },
  });

  // const { data: schools } = useQuery<School[]>({
  //   queryKey: [GET_SCHOOLS],
  //   queryFn: async () => {
  //     return await request<School[]>({
  //       method: "GET",
  //       url: "/school",
  //     });
  //   },
  // });

  const onSubmit = () => {
    try {
      navigate("/auth/join/guardian-connect");
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (student.schoolType) {
      setSchoolType(student.schoolType);
    }
  }, [student.schoolType]);

  return (
    <JoinTemplate>
      <Form
        processBar={<JoinProcessBar stepNow={5} stepTotal={6} />}
        title="학생 회원 정보 입력"
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="다음"
            disabled={false}
            onClick={handleSubmit(onSubmit)}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="text"
            label="뒤로"
            onClick={() => navigate("/auth/join/account-form")}
          />
        }
      >
        <FormInputBox formTitle="회원정보 입력">
          <>
            <TextControl
              control={control}
              name="student.name"
              label="학생 이름"
              placeholder="이름을 입력하세요."
              required={true}
              value={student.name}
              onChange={(e) => handleNameChange(e, "student")}
              instructions="name"
            />
            <TextControl
              type="date"
              control={control}
              name="student.birth"
              label="학생 생년월일"
              placeholder="생년월일을 입력하세요."
              required={true}
              value={
                student.birth ? student.birth.toISOString().split("T")[0] : ""
              }
              onChange={(e) => handleBirthChange(e, "student")}
              instructions="birth"
            />
            <RadioControl
              size="lg"
              control={control}
              name="student.gender"
              label="성별"
              data={[
                { value: "M", displayExpr: "남" },
                { value: "F", displayExpr: "여" },
              ]}
              required={true}
              defaultValue={student.gender}
              onChange={handleGenderChange}
            />
            <TelControl
              type="tel"
              control={control}
              name="student.tel"
              label="연락처"
              placeholder="000-0000-0000"
              required={true}
              value={student.tel}
              onChange={(e) => handleNumberChange(e, "student")}
            />
            <InputGroup direction="row" gridColumn="40% calc(60% - 4px)">
              <>
                <RadioControl
                  size="lg"
                  control={control}
                  name="join.entityType"
                  label="참여 유형"
                  data={[
                    { value: "individual", displayExpr: "개인" },
                    { value: "organization", displayExpr: "단체" },
                  ]}
                  required={true}
                  defaultValue={joinComm.entityType}
                  onChange={handleEntityTypeChange}
                />
                <TextControl
                  control={control}
                  name="join.organizationName"
                  placeholder="소속 기관을 입력하세요."
                  required={joinComm.entityType === "organization"}
                  value={joinComm.organizationName}
                  onChange={handleOrganizationNameChange}
                  instructions="organizationName"
                  disabled={joinComm.entityType !== "organization"}
                />
              </>
            </InputGroup>
            <InputGroup direction="row" gridColumn="40% calc(60% - 4px)">
              <>
                <InputSelect
                  name="student.schoolType"
                  label="학교/소속명"
                  placeholder="학교/소속 구분"
                  required={true}
                  value={student.schoolType}
                  onChange={handleSchoolTypeChange}
                  options={[
                    { label: "구분", value: "" },
                    { label: "초등학교", value: "elementary" },
                    { label: "중학교", value: "middle" },
                    { label: "기타", value: "etc" },
                  ]}
                />
                {student.schoolType === "etc" ? (
                  <TextControl
                    control={control}
                    name="student.schoolId"
                    placeholder="학교/소속명을 입력하세요."
                    required={true}
                    value={student.schoolId}
                    onChange={handleEtcNameChange}
                    instructions="schoolEtc"
                  />
                ) : (
                  //   <SelectControl
                  //   name="student.schoolId"
                  //   control={control}
                  //   placeholder="학교명"
                  //   required={true}
                  //   value={student.schoolId}
                  //   onChange={handleSchoolIdChange}
                  //   options={schools
                  //     ?.filter((school) => school.type === schoolType)
                  //     .map((school) => {
                  //       return { label: school.name, value: school.id };
                  //     })}
                  // />
                  <TextControl
                    control={control}
                    name="student.schoolId"
                    placeholder="학교명을 입력하세요."
                    required={true}
                    value={student.schoolId}
                    onChange={handleEtcNameChange}
                    instructions="schoolNotEtc"
                  />
                )}
              </>
            </InputGroup>
            <TextControl
              control={control}
              name="student.studentIdNumber"
              label="학번(학년+반+번호)"
              placeholder="(예) 6학년 5반 13번일 경우, '6513' 입력"
              value={student.studentIdNumber}
              onChange={handleStudentIdNumberChange}
              instructions="schoolNum"
            />
          </>
        </FormInputBox>
      </Form>
    </JoinTemplate>
  );
};
